import React from "react";
import classNames from "classnames";

import Icon from "../../../../assets/icon_config";
import WordOverflowTooltip from "@components/wordOverflowTooltip/WordOverflowTooltip";

export const Percentage = (props: any) => {
    const _percentage = props.percentage ? props.percentage : 0;
    const percentClassName = classNames(
        "ui-population-insight__percentage",
        {
            "ui-population-insight__percentage--ngtv":
                props.formulaOpposite ? _percentage >= 0 : _percentage < 0,
            "ui-population-insight__percentage--pstv":
                props.formulaOpposite ? _percentage < 0 : _percentage >= 0,
        }
    );

    let iconName;
    
    if( props.formulaOpposite ) {
        iconName = _percentage >= 0 ? "arrowDownSolidFill" : "arrowUpSolidFill"
    } else {
        iconName = _percentage < 0 ? "arrowDownSolidFill" : "arrowUpSolidFill"
    }

    return (
        <div className={percentClassName}>
            <Icon name={iconName} />
            <WordOverflowTooltip text={(_percentage + ' %').replace('-','')}/>
        </div>
    );
};